<template>
    <header class="--bgSolid --withBorder d-flex justify-content-between align-items-center">

        <!-- Logo -->
        <img class="img-fluid header__logo" src="assets/img/adoptuj-kravicku-logo.svg" alt="adoptuj-kravicku-logo">

        <!-- Droprown + Sidemenu -->
        <menu-user 
            v-if="profil.pouzivatel_id" 
            :profil="profil"
        />

    </header>
</template>



<script>
    import MenuUser from '../partials/MenuUser.vue'
    export default {
        components: {
            MenuUser
        },
        props: [
            'profil'
        ],
        mounted() {
            this.toggleBodyClass('addClass', 'profile')
            if (typeof(this.profil.id) == "undefined" || this.profil.id == 0) {
                this.$emit('updateProfil')
            }
        },
        destroyed() {
            this.toggleBodyClass('removeClass', 'profile')
        },
        methods: {
            // mounted + destroy
            toggleBodyClass(addRemoveClass, className) {
                const el = document.body
                if (addRemoveClass === 'addClass') {
                    el.classList.add(className)
                } else {
                    el.classList.remove(className)
                }
            }
        }
    }
</script>